import { inject, Injectable } from '@angular/core';
import { UserService } from '@core/data-access/services/user.service';
import { DeviceType } from '@core/utils/models/device.model';
import { User, UserBase, UserType } from '@core/utils/models/user.model';
import { LoginPayload, LogoutPayload, RegisterPayload, SubmitOtpPayload } from '@features/auth/utils/models/auth.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService extends HttpHandler {
  private readonly userService = inject(UserService);

  login(phoneNumber: string): Observable<HttpResponse<UserBase>> {
    const url: string = environment.apiUrls.auth.login;
    const payload: LoginPayload = {
      phone_number: phoneNumber,
      user_type: UserType.user,
    };
    return this.post<HttpResponse<UserBase>>(url, payload);
  }

  register(phoneNumber: string, userSlug: string, affiliateId?: number): Observable<HttpResponse<UserBase>> {
    const url: string = environment.apiUrls.auth.register;
    const payload: RegisterPayload = {
      phone_number: phoneNumber,
      user_slug: userSlug,
      user_type: UserType.user,
      ...(affiliateId && { affiliate_id: affiliateId }),
    };
    return this.post<HttpResponse<UserBase>>(url, payload);
  }

  submitOtp(otp: string, userId: number): Observable<HttpResponse<User>> {
    const url: string = environment.apiUrls.auth.submitOtp;
    const udid = this.userService.getUniqueDeviceID();
    const params: SubmitOtpPayload = {
      user_id: userId,
      otp,
      device_type: DeviceType.web,
      user_type: UserType.user,
      device_token: udid,
      udid,
    };
    return this.post<HttpResponse<User>>(url, params);
  }

  checkUserSlugAvailability(userSlug: string): Observable<HttpResponse<string>> {
    const url: string = environment.apiUrls.auth.checkUserSlugAvailability;
    const payload = {
      user_slug: userSlug,
    };
    return this.post<HttpResponse<string>>(url, payload);
  }

  logout(userId: number): Observable<HttpResponse<string>> {
    const url: string = environment.apiUrls.auth.logout;
    const udid = this.userService.getUniqueDeviceID();
    const payload: LogoutPayload = {
      user_id: userId,
      device_token: udid,
      udid,
    };
    return this.post<HttpResponse<string>>(url, payload);
  }
}
